import TotalPriceFormattedContainer from './TotalPriceFormattedContainer';

export default TotalPriceFormattedContainer;
